import { useEffect, useState } from "react";
import { _EmployeeContract, _EmployeeContractHistory, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { _EmployeeFactorsConsolidated, _FunctionalAreaToEmployee, _ViewForEmployee } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectFunctionalArea } from "../../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { AccountEditor } from "../../../editor/AccountEditor";
import { ValueTypeSelector } from "../../../Talentohumano/ParametrosTalentoHumano/ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { FortnightTypeConstants } from "../../../Talentohumano/ParametrosTalentoHumano/PayrollFactor/FortnightTypeConstants";
import { PayrollFactorNameList } from "./PayrollFactorNameList";
import { AppointmentEditor } from "../../../Talentohumano/ParametrosTalentoHumano/Appointment/Appointment.editor";
import { EntailmentEditor } from "../../../Talentohumano/ParametrosTalentoHumano/Entailment/Entailment.editor";

export const EmployeeFactorsConsolidated = () => {

    const employeefactor = useDataBean(_EmployeeFactorsConsolidated);
    const ViewForEmployee = useDataBean(_ViewForEmployee);
    // const employeeContracttofunctional = useDataBean(_FunctionalAreaToEmployee);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Year, setYear] = useState<any>(_single.getCurrenYear());
    const [Account, setAccount] = useState<any>(null);
    const [Value, setValue] = useState<any>(38);
    const [GeneratedViewId, setGeneratedViewId] = useState<string | null>(null);
    const [Fornight, setFornight] = useState<any>(null);
    const [NameList, setNamelist] = useState<any>(null);
    const [Appointment, setAppointment] = useState<any>(null);
    const [EntailmentName, setEntailmentName] = useState<any>(null);
    const [records, setRecords] = useState<number>(15);
    const [modaldefinirplaza, setModaldefinirplaza] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        employeefactor.instance.getEmployeeFactorsConsolidated(GeneratedViewId, Year, Account, Value, Fornight, NameList, Appointment, EntailmentName, paginador.page, 15).then(
            (resp) => {
                //console.log(resp.NumberOfPages)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)

                setLista(resp.List)
            }
        )
    }

    const getViewForEmployee = () => {
        ViewForEmployee.instance.getViewForEmployeeFactorsConsolidated(Year, Account, Value, Fornight, NameList, Appointment, EntailmentName, paginador.page, 15).then(
            (resp) => {
                const value = resp ?? null;
                setGeneratedViewId(value);
                // setValue(value); // Esto actualiza el parámetro "Value" del primer servicio
                toast.success("Vista generada exitosamente");
            }
        )
    }

    const head = [
        { title: 'IDContrato', property: 'IDPayrollData', visible: true },
        { title: 'Nombres', property: 'Names', visible: true },
        { title: 'Apellidos', property: 'Surnames', visible: true },
        { title: 'Enero', property: 'Month0', visible: true },
        { title: 'Febrero', property: 'Month1', visible: true },
        { title: 'Marzo', property: 'Month2', visible: true },
        { title: 'Abril', property: 'Month3', visible: true },
        { title: 'Mayo', property: 'Month4', visible: true },
        { title: 'Junio', property: 'Month5', visible: true },
        { title: 'Julio', property: 'Month6', visible: true },
        { title: 'Agosto', property: 'Month7', visible: true },
        { title: 'Septiembre', property: 'Month8', visible: true },
        { title: 'Octubre', property: 'Month9', visible: true },
        { title: 'Noviembre', property: 'Month10', visible: true },
        { title: 'Diciembre', property: 'Month11', visible: true },
    ]


    const listaBotones = () => {
        const botones = [

            { titulo: '', icono: 'ri-edit-2-line', visible: single.canDelete(), evento: () => { setModaldefinirplaza({ ...modaldefinirplaza, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Histórico de Cambios de Factores Salariales por Funcionario, Nivel Salarial o Jeráquico">

            <div className="row">
                <div className="col-md-4">
                    <YearSelector tittle="Año" value={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Empleado" />
                </div>
                <div className="col-md-4">
                    <ValueTypeSelector idSelector={Value} onChange={(e) => { setValue(e) }} />
                </div>
                <div className="col-md-4">
                    <FortnightTypeConstants idSelector={Fornight} onChange={(e) => { setFornight(e) }} />
                </div>
                <div className="col-md-4">
                    <PayrollFactorNameList year={Year} valueType={Value} fornightType={Fornight} idSelector={NameList} onChange={(e) => { setNamelist(e) }} />
                </div>
                <div className="col-md-4">
                    <AppointmentEditor label="Nivel Salarial" idSelector={Appointment} onChange={(e) => { setAppointment(e) }} />
                </div>
                <div className="col-md-4">
                    <EntailmentEditor label="Nivel Jerárquico" idSelector={EntailmentName} onChange={(e) => { setEntailmentName(e) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton value="Buscar" icon="ri-file-add-line" eventClick={getLista} disable={!GeneratedViewId}></BasicButton>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton value="Crear Vista de Factores" icon="ri-file-add-line" eventClick={getViewForEmployee}  ></BasicButton>
                </div>
                {GeneratedViewId && (
                    <div className="col-md-12 mt-2">
                        <div className="alert alert-info">
                            Código de vista generada: <strong>{GeneratedViewId}</strong>
                        </div>
                    </div>
                )}
                <div className="col-md-12">
                    <BasicTable
                        head={head}
                        body={lista}
                        rowSet={employeefactor.setBean}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={records}
                    />
                </div>
            </div>
        </BasicPage>
    )
}